import * as React from 'react';
import { Fade } from 'react-reveal';
import { isEmpty } from 'lodash';
import { Container, StretchContainer } from '../Container';
import { QuickLinks } from '../QuickLinks';
import { HelpSupport } from '../HelpSupport';
import { BannerResponsive } from '../BannerResponsive';
import { Disclaimer } from '../Disclaimer';
import { Animation } from '../Animation';
import { CustomerExperience } from '../CustomerExperience/CustomerExperience';
import { ProspectExperience } from '../ProspectExperience/ProspectExperience';
import { getExperienceOffer } from '../../utils/utils';
import { mboxes } from '../../consts/mboxes';

export const SHOW_ANIMATIONS = true;

export const PageContent = ({ store, signUp }) => {
  const bannerContent = getExperienceOffer(mboxes.bannerMbox);
  const quickLinksContent = getExperienceOffer(mboxes.quickLinksMbox);
  const customerExperience = getExperienceOffer(mboxes.customerAbTestMbox);
  const disclaimerContent = getExperienceOffer(mboxes.disclaimerMbox);
  const isCustomerExperience = !isEmpty(customerExperience);
  return (
    <>
      <BannerResponsive
        {...store.content.banner}
        {...bannerContent}
        showDisclaimer
        verticalOffset={40}
      />

      <Animation
        enabled={SHOW_ANIMATIONS}
        component={Fade}
        ssrFadeout={true}
        effect="fadeInUp"
        duration={350}
        bottom
        ssrReveal
        distance="20%"
      >
        <QuickLinks {...store.content.quicklinks} {...quickLinksContent} verticalOffset={-32} />
      </Animation>
      {isCustomerExperience ? (
        <CustomerExperience store={store} experienceContent={customerExperience} />
      ) : (
        <ProspectExperience store={store} signUp={signUp} />
      )}
      {store.content.helpsupport && (
        <StretchContainer baseSideMargin="0" last>
          <HelpSupport {...store.content.helpsupport} />
        </StretchContainer>
      )}
      {disclaimerContent && (
        <Container>
          <Disclaimer {...disclaimerContent} />
        </Container>
      )}
    </>
  );
};
